import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "booking-success-view" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "success-card" }
const _hoisted_4 = { class: "success-title" }
const _hoisted_5 = { class: "success-subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}
const _hoisted_8 = {
  key: 2,
  class: "appointment-details"
}
const _hoisted_9 = { class: "details-title" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_14 = {
  key: 1,
  class: "detail-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "success-icon" }, [
          _createElementVNode("span", null, "✔")
        ], -1)),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.isEnquiry ? 'Enquiry Submitted!' : 'Appointment Booked!'), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.isEnquiry
               ? 'Thank you for your interest in our academy. Our team will contact you soon with course details.'
               : 'Thank you for scheduling your appointment with us. We look forward to seeing you!'), 1),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.appointment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.isEnquiry ? 'Your Enquiry Details' : 'Your Appointment Details'), 1),
              _createElementVNode("div", _hoisted_10, [
                _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Appointment ID:", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.appointment.id), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Date:", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.appointment.appointment_date)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Status:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["status-pill", `status-${_ctx.appointment.status}`])
                }, _toDisplayString(_ctx.appointment.status), 3)
              ]),
              (_ctx.appointment.customer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Name:", -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.appointment.customer.firstName) + " " + _toDisplayString(_ctx.appointment.customer.lastName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.appointment.services && _ctx.appointment.services.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Services:", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointment.services, (service) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: service.id
                        }, _toDisplayString(service.service ? service.service.name : 'N/A'), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: "/",
          class: "btn btn-primary"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Back to Home")
          ])),
          _: 1,
          __: [5]
        })
      ])
    ])
  ]))
}